import { useEffect, useRef } from 'react';

export const useSkipFirstEffect = (callback: any, dependencies: Array<any>) => {
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
    } else {
      callback();
    }
  }, [...dependencies]);
};
